import { GoodReview } from "./good_review";
import { BadReview } from "./bad_review"

export class SurveyReview {
    constructor(survey_review) {
        this.good_review = new GoodReview(survey_review.good_review);
        this.bad_review = new BadReview(survey_review.bad_review);
    }
}